// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3h-0";
export var eligibilityCardNotEligible = "_3h-1";